import * as storageType from "./localStorageHandler";

export default class Storage {
    storageName = 'hh-storage';

    constructor() {
        if (typeof Storage.instance === 'object') {
            return Storage.instance;
        }

        this.init();
        Storage.instance = this;

        return Storage.instance;
    }

    init() {
        setInterval(this.refreshData.bind(this), 2000); // Очистка просроченных данных (по полю expire)
    }

    refreshData() {
        const allValues = storageType.getAllValues(this.storageName);

        Object.keys(allValues).forEach((key) => {
            const expire = allValues[key].expire;

            if (expire && Date.now() > expire) {
                this.del(key);
            }
        });
    }

    save(key, value, expire = false) {
        if (this.get(key)) {
            return false;
        }

        let fullStorage = storageType.getAllValues(this.storageName);
        fullStorage[key] = {
            value: value,
            expire: expire,
        };
        storageType.save(this.storageName, fullStorage);

        return fullStorage;
    }

    get(key) {
        if (! this.getAllValue(key)) {
            return false;
        }

        return this.getAllValue(key).value;
    }

    getAllValue(key) {
        if (! storageType.storageIsExist(this.storageName)) {
            return false;
        }

        let fullStorage = storageType.getAllValues(this.storageName);

        return fullStorage[key];
    }

    del(key) {
        let fullStorage = storageType.getAllValues(this.storageName);

        delete fullStorage[key];
        this.clear();
        storageType.save(this.storageName, fullStorage)

        return fullStorage;
    }

    edit(key, value, expire = false) {
        if (! this.get(key)) {
            this.save(key, value);

            return storageType.getAllValues(this.storageName);
        }

        this.del(key);
        this.save(key, value, expire);

        return storageType.getAllValues(this.storageName);
    }

    clear() {
        return storageType.clear(this.storageName);
    }

    getAll() {
        return storageType.getAllValues(this.storageName);
    }
}